/** Legal copy aligned with WasOK `docs/PRIVACY_POLICY.md` / `docs/TERMS_OF_SERVICE.md`. */
export const legalMessagesFi = {
  privacy: {
    pageTitle: "Tietosuojakäytäntö",
    lastUpdated: "Viimeksi päivitetty: 1. kesäkuuta 2026",
    introduction: {
      title: "Johdanto",
      body: "WasOK on paikallinen ostosapusovellus, joka on suunniteltu auttamaan käyttäjiä muistamaan tuotteita, joita he ovat aiemmin ostaneet, arvioineet tai arvostelleet.\n\nTämä tietosuojakäytäntö selittää, mitä tietoja käsitellään sovellusta käytettäessä, miten tietoja tallennetaan ja miten tietyt kolmannen osapuolen palvelut voivat toimia.",
    },
    dataStored: {
      title: "Sovelluksen tallentamat tiedot",
      body: "WasOK tallentaa seuraavat tiedot paikallisesti laitteellesi:\n\n• skannatut tuoteviivakoodit\n• käyttäjän syöttämät tuotenimet ja -tiedot\n• arviot ja kommentit\n• ostoslistat\n• tuotekategoriat\n• hinnat ja kaupan tiedot\n• tuote- ja kauppakuvat\n\nTuotetietojasi ja kuviasi ei ladata WasOK:n palvelimille.",
    },
    permissions: {
      title: "Käytetyt käyttöoikeudet",
      camera: {
        title: "Kamera",
        body: "Kameran käyttöoikeutta käytetään:\n\n• viivakoodien skannaamiseen\n• tuotekuvien ottamiseen",
      },
      photos: {
        title: "Kuvat ja media",
        body: "Kuva- tai galleriayhteyttä käytetään vain, kun:\n\n• liität kuvia tuotteisiin\n• palautat varmuuskopioita, jotka sisältävät kuvia",
      },
      files: {
        title: "Tiedosto- ja tallennusyhteys",
        body: "Tiedostoyhteyttä voidaan käyttää:\n\n• varmuuskopiotiedostojen viemiseen\n• käyttäjän valitsemien varmuuskopioiden tuomiseen\n• ostoslistojen tai varmuuskopioiden jakamiseen",
      },
    },
    backup: {
      title: "Varmuuskopiointi ja vienti",
      body: "WasOK antaa käyttäjien luoda varmuuskopiotiedostoja, jotka sisältävät sovellustietoja ja valinnaisesti kuvia.\n\nVarmuuskopiotiedostot luodaan paikallisesti laitteellesi, ja niitä voidaan tallentaa tai jakaa käyttäjän valitsemilla palveluilla, kuten:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• paikallinen laitteen tallennustila\n\nWasOK ei lataa varmuuskopioita omille palvelimilleen.",
      onlineProductLookup: {
        title: "Verkkotuotehaku",
        body: "Kun otat verkkoviivakoodihaun käyttöön Asetuksissa, WasOK voi lähettää vain skannatun viivakoodinumeron julkisiin tuotetietokantoihin (kuten Open Food Facts) ehdottaakseen tuotenimeä ja -merkkiä. WasOK ei lataa arvioitasi, kommenttejasi, kuviasi, ostoslistojasi, kategorioitasi, kaupan tietoja tai varmuuskopioita tämän ominaisuuden yhteydessä. Voit poistaa tämän käytöstä milloin tahansa Asetuksissa.",
      },
    },
    advertising: {
      title: "Mainonta ja kolmannen osapuolen palvelut",
      intro:
        "WasOK käyttää valittuja kolmannen osapuolen palveluita tiettyjen ominaisuuksien tarjoamiseen.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMobia käytetään mainosten näyttämiseen sovelluksessa.\n\nGoogle ja sen kumppanit voivat käsitellä tietoja, kuten:\n\n• mainostunnisteita\n• laitetietoja\n• IP-osoitetta\n• diagnostiikka- ja käyttötietoja\n\nTietyillä alueilla käyttäjiltä voidaan pyytää suostumus ennen personoitujen mainosten näyttämistä.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK käyttää Firebase Crashlyticsia kaatumisten tunnistamiseen ja sovelluksen vakauden parantamiseen.\n\nKaatumisraportit voivat sisältää teknisiä tietoja, kuten:\n\n• laitemalli\n• käyttöjärjestelmäversio\n• sovellusversio\n• kaatumisdiagnostiikka\n\nKaatumisraportit eivät tarkoituksella sisällä tuotearvioitasi, muistiinpanojasi, ostoslistojasi tai kuviasi.",
      },
      externalProductDatabases: {
        title: "Ulkoiset tuotetietokannat",
        body: "Viivakoodihakutoiminto voi käyttää ulkoisia tuotetietokantoja tuote­tietojen hakemiseen.\n\nLisätietoja saat tarkistamalla kyseisten palveluntarjoajien tietosuojakäytännöt.",
      },
    },
    dataSecurity: {
      title: "Tietoturva",
      body: "WasOK tallentaa sovellustiedot paikallisesti laitteellesi käyttöjärjestelmän tarjoamilla tallennusmekanismeilla.\n\nVaikka paikallisten sovellustietojen suojaamiseksi ryhdytään kohtuullisiin toimenpiteisiin, mikään sähköisen tallennuksen menetelmä ei ole täysin turvallinen.\n\nKäyttäjät vastaavat tärkeiden tietojen varmuuskopioinnista halutessaan.",
    },
    children: {
      title: "Lasten tietosuoja",
      body: "WasOK ei ole suunnattu alle 13-vuotiaille lapsille.",
    },
    notifications: {
      title: "Ilmoitukset",
      body: "WasOK voi valinnaisesti luoda paikallisia ilmoituksia laitteellesi muistuttaakseen sinua arvioimaan tuotteita ostoksen jälkeen.\n\nNämä ilmoitukset luodaan ja ajoitetaan paikallisesti laitteellesi, eikä niihin tarvita tiliä tai etäpalvelinta.\n\nVoit poistaa ilmoitukset käytöstä milloin tahansa laitteesi asetuksista tai sovelluksesta, jos tuettu.",
    },
    yourControl: {
      title: "Hallintasi tietoihin",
      body: "Voit:\n\n• muokata tai poistaa tallennettuja tuotteita milloin tahansa\n• tyhjentää sovellustiedot laitteeltasi\n• poistaa sovelluksen asennuksen\n• viedä tietojesi varmuuskopioita",
    },
    changes: {
      title: "Muutokset tähän käytäntöön",
      body: "Tätä tietosuojakäytäntöä voidaan päivittää ajoittain.\n\nMuutokset tulevat voimaan, kun päivitetty versio julkaistaan.",
    },
    contact: {
      title: "Yhteystiedot",
      body: "Jos sinulla on kysymyksiä tästä tietosuojakäytännöstä, ota yhteyttä:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Käyttöehdot",
    lastUpdated: "Viimeksi päivitetty: 1. kesäkuuta 2026",
    acceptance: {
      title: "Ehtojen hyväksyminen",
      body: "Lataamalla, asentamalla tai käyttämällä WasOK:ia hyväksyt nämä käyttöehdot.\n\nJos et hyväksy näitä ehtoja, älä käytä sovellusta.",
    },
    license: {
      title: "Lisenssi",
      body: "WasOK myöntää sinulle rajoitetun, ei-yksinomaisen, siirtokelvottoman, peruutettavissa olevan lisenssin käyttää sovellusta näiden ehtojen mukaisesti.",
    },
    acceptableUse: {
      title: "Hyväksyttävä käyttö",
      body: "Sitoudut olemaan:\n\n• käyttämättä sovellusta väärin\n• häiritsemättä sovelluksen toimintaa\n• yrittämättä reverse-engineerata tai muokata sovellusta\n• käyttämättä sovellusta sovellettavien lakien tai määräysten vastaisesti",
    },
    localData: {
      title: "Paikalliset tiedot ja varmuuskopiot",
      body: "WasOK tallentaa käyttäjätiedot paikallisesti laitteelle.\n\nKäyttäjät vastaavat tärkeiden tietojen varmuuskopioinnista halutessaan.\n\nVaikka varmuuskopiointi- ja palautustoimintoja voidaan tarjota, WasOK ei takaa tallennettujen tietojen häviämättömyyttä, eheyttä tai toimivuutta.",
    },
    advertisements: {
      title: "Mainokset",
      body: "Sovellus voi näyttää mainoksia, jotka tarjoavat kolmannen osapuolen mainoskumppanit, mukaan lukien Google AdMob.",
    },
    noWarranty: {
      title: "Ei takuuta",
      body: "WasOK tarjotaan \"sellaisenaan\" ja \"saatavuuden mukaan\" ilman minkäänlaisia takuita, nimenomaisia tai oletettuja.\n\nEmme takaa, että:\n\n• sovellus on aina saatavilla\n• sovellus on virheetön\n• tietojen menetystä ei koskaan tapahdu\n• kaikki ominaisuudet toimivat keskeytyksettä kaikilla laitteilla",
    },
    limitationLiability: {
      title: "Vastuunrajoitus",
      body: "Lain sallimassa enimmäislaajuudessa WasOK ja sen kehittäjät eivät ole vastuussa:\n\n• tietojen menetyksestä\n• voiton menetyksestä\n• laiteongelmista\n• epäsuorista tai seurannaisvahingoista\n• keskeytyksistä, jotka johtuvat sovelluksen käytöstä tai kyvyttömyydestä käyttää sitä",
    },
    thirdParty: {
      title: "Kolmannen osapuolen palvelut",
      body: "Tietyt ominaisuudet tai sisältö voivat perustua kolmannen osapuolen palveluihin, mukaan lukien mainostajat sekä käyttäjän valitsemat ulkoiset tallennus-/jakopalvelut.\n\nWasOK ei ole vastuussa kolmannen osapuolen palveluista tai niiden käytännöistä.",
    },
    productInformation: {
      title: "Tuotetiedot",
      body: "Tietyt tuotetiedot voidaan hankkia kolmannen osapuolen viivakoodihakupalveluista.\n\nWasOK ei takaa ulkoisten tietolähteiden tarjoamien tietojen tarkkuutta, täydellisyyttä, saatavuutta tai soveltuvuutta.\n\nKäyttäjien tulee tarvittaessa tarkistaa tuotetiedot itsenäisesti.",
    },
    changesApp: {
      title: "Muutokset sovellukseen",
      body: "WasOK:ia voidaan muokata, päivittää, keskeyttää tai lopettaa milloin tahansa ilman ennakkoilmoitusta.",
    },
    changesTerms: {
      title: "Muutokset näihin ehtoihin",
      body: "Näitä ehtoja voidaan päivittää säännöllisesti.\n\nSovelluksen jatkuva käyttö päivitysten tultua voimaan merkitsee tarkistettujen ehtojen hyväksymistä.",
    },
    contact: {
      title: "Yhteystiedot",
      body: "Kysymyksiä näistä ehdoista varten, ota yhteyttä:\n\nsupport@wasok.app",
    },
  },
};
